export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_MUNICIPIOS_COLETA = 'municipiosColeta';
export const SET_ESTADOS_COLETA = 'estadosColeta';
export const SET_PESO = 'peso';
export const SET_VALOR_MERCADORIA = 'valorMercadoria';
export const SET_SELECTED_SORT = 'selectedSort';
export const SET_MUNICIPIOS_ENTREGA = 'municipiosEntrega';
export const SET_ESTADOS_ENTREGA = 'estadosEntrega';
